import React, { useState } from 'react';
import { Box, Button, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { ExpandLess, ExpandMore, KeyboardArrowLeft, KeyboardArrowRight, ContentCopy, WhatsApp } from '@mui/icons-material';
import { headingBlue, lightGrey, maroon, mediumGrey, yellowish, red, orange, textGeen, green } from '../../assets/colors';
import CustomDropDown from '../CustomDropDown';
import CustomTextField from '../CustomTextField';
import { tableOffsets } from '../../utils/constants';
import { useDispatch } from 'react-redux';
import { showSnackBar } from '../CustomComponents/CustomComponentsSlice';
import RegistrationInviteDetails from './RegistrationInviteDetails';

const outerBoxStyle = {
  width: '100%',
  height: '70vh', 
  marginTop: "0.2rem"
};

const paperStyle = {
  border: '1px solid #D9D9D9',
  padding: "0.2rem 0.1rem 0.1rem 0.1rem",
};

const headerBoxStyle = {
  display: 'flex',
  padding: "0.3rem",
  flexWrap: 'wrap',
};

const internalBoxStyle = {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  width: '20%',
  flex: '1 1',
  flexDirection: "row",
  flexWrap: 'wrap'
};

const typographyStyle = {
  marginLeft: "0.5rem",
  padding: "0.1rem",
  fontSize: "1rem",
  fontWeight: "600"
};

const buttonStyle = {
  backgroundColor: headingBlue,
  color: 'white',
  marginLeft: "0.7rem",
  fontFamily: "Helvetica",
  fontWeight: '300',
  fontSize: '0.9rem',
  padding: "0.2rem 1rem"
};

const headerCellStyle = {
  padding: '0.2rem 0.5rem', 
  fontSize: "0.9rem",
  fontWeight: "400",
  textAlign: 'center'
};

const scrollbarStyle = {
  "&::-webkit-scrollbar": { display: 'none' },
  scrollbarWidth: "none"
};

const filterOptions = [
  { name: 'Filter On' },
  { name: 'Name' },
  { name: 'Contact Number' },
  { name: 'District' },
  { name: 'State' },
  { name: 'Status' }
];

const getStatusProps = (status) => {
  switch (status) {
    case 'generated': return { label: 'Generated', color: yellowish };
    case 'expired': return { label: 'Expired', color: red };
    case 'exhausted': return { label: 'Exhausted', color: orange };
    case 'underVerification': return { label: 'Under Verification', color: textGeen };
    case 'verified': return { label: 'Verified', color: green };
    case 'rejected': return { label: 'Rejected', color: red };
    default: return { label: status || '-', color: 'inherit' };
  }
};

const GenerateInvitesTable = (props) => {
  const dispatch = useDispatch();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  return (
    <Box style={outerBoxStyle}>
      <Paper style={paperStyle}>
        
        {/* Top Action Bar */}
        <Box style={headerBoxStyle}>
          <Box style={internalBoxStyle}>
            <Typography style={typographyStyle}>Registration Invites</Typography>
          </Box>
          <Box style={{ display:'flex', flex: "1 1", width: "80%", justifyContent: 'flex-end', padding: "0 0.5rem", flexWrap: 'wrap', gap: '0.5rem' }}>
            <CustomDropDown key='tableFilters' width="11rem" list={filterOptions} value={props.filterOnValue} placeHolder='Filter On' setFunc={props.updateFilterOn} regular={true} />
            <CustomTextField placeHolder="Enter Text to Filter" value={props.filterByValue} setFunc={props.updateFilterBy} />
          </Box>
        </Box>

        {/* Table Area */}
        <Box style={{ display: 'flex', justifyContent: 'center', overflow: 'auto' }}>
          <TableContainer component={Paper} sx={{ width: '98%', height: "55vh", border: '1px solid #D9D9D9', mt: 0.2, ...scrollbarStyle }}>
            <Table stickyHeader>
              <TableHead style={{ backgroundColor: mediumGrey }}>
                <TableRow>
                  <TableCell style={{ ...headerCellStyle, backgroundColor: lightGrey }}>
                    <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', color: headingBlue }}>
                      Name <br></br> Contact Number
                      <Box style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                        <IconButton style={{ padding: "0 0 0 0.2rem", marginBottom: '-0.2rem', color: headingBlue }} size='small' onClick={() => props.updateSort('name', 1)}>
                          <ExpandLess fontSize="small"/>
                        </IconButton>
                        <IconButton style={{ padding: "0 0 0 0.2rem", marginTop: '-0.2rem', color: headingBlue }} size='small' onClick={() => props.updateSort('name', -1)}>
                          <ExpandMore fontSize="small"/>
                        </IconButton>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell style={{ ...headerCellStyle, backgroundColor: lightGrey }}>District <br></br> State</TableCell>
                  <TableCell style={{ ...headerCellStyle, backgroundColor: lightGrey }}>Link</TableCell>
                  <TableCell style={{ ...headerCellStyle, backgroundColor: lightGrey }}>Expiry Date</TableCell>
                  <TableCell style={{ ...headerCellStyle, backgroundColor: lightGrey }}>Generated By</TableCell>
                  <TableCell style={{ ...headerCellStyle, backgroundColor: lightGrey }}>Status</TableCell>
                  <TableCell style={{ ...headerCellStyle, backgroundColor: lightGrey }}>Reviewed By</TableCell>
                  <TableCell style={{ ...headerCellStyle, backgroundColor: lightGrey }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody style={{ textAlign: 'center' }}>
                {props?.data?.data?.length > 0 ? (
                  props?.data?.data?.map((row, index) => (
                    <TableRow 
                      key={index}
                      onClick={() => {
                        if (row.status !== 'generated') {
                          setSelectedRowData(row);
                          setDialogOpen(true);
                        }
                      }}
                      style={{ cursor: row.status !== 'generated' ? 'pointer' : 'default' }}
                      hover={row.status !== 'generated'}
                    >
                      <TableCell style={headerCellStyle}>
                        <Typography variant="body2">{row.name || '-'}</Typography>
                        <Typography variant="caption" color="textSecondary">{row.contactNumber || '-'}</Typography>
                      </TableCell>
                      <TableCell style={headerCellStyle}>
                        <Typography variant="body2">{row.district || '-'}</Typography>
                        <Typography variant="caption" color="textSecondary">{row.state || '-'}</Typography>
                      </TableCell>
                      <TableCell style={{ ...headerCellStyle, maxWidth: '200px' }}>
                        {row?.token ? (
                          <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Typography style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '160px' }}>
                              <a href={`${process.env.REACT_APP_URL}register?${row?.token}`} target="_blank" rel="noopener noreferrer" style={{ color: headingBlue }} onClick={(e) => e.stopPropagation()}>
                                {process.env.REACT_APP_URL}register?${row?.token}
                              </a>
                            </Typography>
                            <IconButton size="small" onClick={(e) => {
                              e.stopPropagation();
                              navigator.clipboard.writeText(`${process.env.REACT_APP_URL}register?${row?.token}`);
                              dispatch(showSnackBar({ message: 'Link copied to clipboard!', severity: 'success' }));
                            }} style={{ marginLeft: '0.3rem', color: headingBlue }}>
                              <ContentCopy fontSize="small" />
                            </IconButton>
                          </Box>
                        ) : '-'}
                      </TableCell>
                      <TableCell style={headerCellStyle}>
                        {row.expiresAt ? (
                          <>
                            <Typography variant="body2">{row.expiresAt.split('T')[0]}</Typography>
                            {row.expiresAt.split('T')[1] && (
                              <Typography variant="caption" color="textSecondary">{row.expiresAt.split('T')[1]}</Typography>
                            )}
                          </>
                        ) : '-'}
                      </TableCell>
                      <TableCell style={headerCellStyle}>
                        <Typography variant="body2">{row.generatedBy || '-'}</Typography>
                        <Typography variant="caption" color="textSecondary">{row.generatedByCN || '-'}</Typography>
                      </TableCell>
                      <TableCell style={{ ...headerCellStyle, color: getStatusProps(row.status).color, fontWeight: 500 }}>
                        {getStatusProps(row.status).label}
                      </TableCell>
                      <TableCell style={headerCellStyle}>
                         <Typography variant="body2">{row.reviewedBy || '-'}</Typography>
                        <Typography variant="caption" color="textSecondary">{row.reviewedByCN || '-'}</Typography>
                      </TableCell>
                      <TableCell style={headerCellStyle}>
                    <IconButton 
                      size="small" 
                      disabled={row.status !== 'generated'}
                      onClick={(e) => {
                        e.stopPropagation();
                        const message = `Hi ${row.name || ''},\n\nHere is the registration link to complete your membership for WORK:\n${process.env.REACT_APP_URL}register?${row?.token}\n\nPlease complete it. For any help, message me.\n\nThanks\nWORK Team`;
                        window.open(`https://wa.me/+91${row.contactNumber}?text=${encodeURIComponent(message)}`, '_blank');
                      }} 
                      style={{ color: row.status !== 'generated' ? mediumGrey : green }}
                    >
                          <WhatsApp fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={8} style={{ ...headerCellStyle, padding: '1rem', color: maroon }}>
                      No Records Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>  
        </Box>
        
        {/* Pagination Area */}
        <Box style={{ display: 'flex', justifyContent: 'center', padding: "0.4rem 0rem 0.1rem 0rem" }}>
          
          {/* 1. Record Count (Left) */}
          <Box style={{ width: "30%", display: 'flex', justifyContent: 'flex-start', alignItems: 'center', padding: "0rem 0.5rem 0rem 0.9rem" }}>
            <Typography style={{ color: maroon, fontSize: '0.9rem' }}>
              {((props.pageValue - 1) * props.offsetValue) + 1} - {Math.min(props.pageValue * props.offsetValue, props?.data?.totalRecords || 0)} of {props?.data?.totalRecords || 0}
            </Typography>
          </Box>

          {/* 2. Page Controls (Center) */}
          <Box style={{ width: '40%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <IconButton 
              size='small'
              onClick={() => { if(props.pageValue > 1) props.updatePage(props.pageValue - 1) }}
              disabled={props.pageValue === 1}
            >
              <KeyboardArrowLeft size='small' sx={{ color: props.pageValue === 1 ? mediumGrey : headingBlue }} />
            </IconButton>
            
            <Button variant='contained' style={{ minWidth: '0rem', width: '1.5rem', height: '1.5rem', borderRadius: '50%', backgroundColor: headingBlue, color: 'white', padding: '0rem' }}>
              {props.pageValue}
            </Button>
            
            <IconButton 
              size='small'
              onClick={() => { if(props.pageValue < props?.data?.totalPages) props.updatePage(props.pageValue + 1) }}
              disabled={props.pageValue === props?.data?.totalPages || !props?.data?.totalPages}
            >
              <KeyboardArrowRight size='small' sx={{ color: (props.pageValue === props?.data?.totalPages || !props?.data?.totalPages) ? mediumGrey : headingBlue }} />
            </IconButton>
          </Box>

          {/* 3. Offset Dropdown (Right) */}
          <Box style={{ width: '30%', display: 'flex', justifyContent: 'flex-end', padding: "0rem 0.6rem 0rem 0rem" }}>
            <CustomDropDown 
              key='table' 
              value={props.offsetValue} 
              width="5rem" 
              setFunc={props.updateOffset} 
              list={tableOffsets} 
              regular={true} 
            />
          </Box>

        </Box>

        <RegistrationInviteDetails
          dialogStatus={dialogOpen}
          updateDialogStatus={(status, refresh) => {
            setDialogOpen(status);
            if (refresh && props.onRefresh) props.onRefresh();
          }}
          data={selectedRowData}
        />

      </Paper>
    </Box>
  );
};

export default GenerateInvitesTable;